import 'magnific-popup';

$('.js-popup-more').magnificPopup({
	type:'inline',
	midClick: true,
	fixedContentPos: true,
	fixedBgPos: true,
});